function ZoneCardView(aZone, aAgent, aOrganization) {
    "use strict";

    this.Id = aZone.Id;
    this.Name = aZone.Name;
    this.Description = aZone.Description;
    this.Type = aZone.Type;
    this.Scope = aZone.Scope;
    this.Shape = aZone.Shape;
    this.IsAssigned = (aZone.EnrolleeCount > 0);
    this.EventCount = aZone.EventCount;
    this.PoiFlag = aZone.PoiFlag;
    if (aZone.Id === 9221) {
        var l = '';
    }
    this.EnrolleeCount = aZone.EnrolleeCount;

    this.IsMine = false;

    this.AgentId = aZone.AgentId;
    this.AgentName = '- unknown -';
    if (!isNullOrUndefined(aAgent)) {
        this.AgentName = aAgent.FullName;
    }

    this.OrganizationId = aZone.OrganizationId;
    this.OrganizationName = '- unknown -';
    if (!isNullOrUndefined(aOrganization)) {
        this.OrganizationName = aOrganization.Name;
    }

    this.ZoneClassificationId = aZone.ZoneClassificationId;
}
if (typeof exports !== 'undefined') {
    module.exports = ZoneCardView;
}